import { defineStudioUrlStore } from './defineStudioUrlStore';
export function defineUseLiveMode({ enableLiveMode, studioUrlStore, }) {
    return ({ allowStudioOrigin, client, onConnect, onDisconnect, studioUrl } = {}) => {
        if (allowStudioOrigin) {
            // eslint-disable-next-line no-console
            console.warn('`allowStudioOrigin` is deprecated and no longer needed');
        }
        studioUrlStore.set(studioUrl ??
            (typeof client === 'object'
                ? client?.config().stega.studioUrl
                : undefined));
        return enableLiveMode({
            client,
            onConnect,
            onDisconnect,
        });
    };
}
